var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailPrompt = function SvgEmailPrompt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 46",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#737d8c",
    d: "M4 17c-.5 0-.975.096-1.416.264L20 34.68l17.416-17.416A4 4 0 0 0 36 17ZM.264 19.584A4 4 0 0 0 0 21v21a4 4 0 0 0 4 4h32a4 4 0 0 0 4-4V21c0-.5-.096-.975-.264-1.416L21.16 38.16a1.6 1.6 0 0 1-.533.356 1.6 1.6 0 0 1-.627.125 1.6 1.6 0 0 1-.627-.125 1.6 1.6 0 0 1-.533-.356z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dbd8b",
    fillOpacity: 0.1,
    d: "M57 16a16 16 0 0 1-16 16 16 16 0 0 1-16-16A16 16 0 0 1 41 0a16 16 0 0 1 16 16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53 16a12 12 0 0 1-12 12 12 12 0 0 1-12-12A12 12 0 0 1 41 4a12 12 0 0 1 12 12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dbd8b",
    d: "M49 16a8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailPrompt);
export default ForwardRef;